import { render, staticRenderFns } from "./LongTermLeave.vue?vue&type=template&id=4d3aa9d1&"
import script from "./LongTermLeave.vue?vue&type=script&lang=js&"
export * from "./LongTermLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports